import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import WebinarPost from "@/pages/WebinarPost";

export const Route = createFileRoute("/es/webinar-on-demand/$slug")({
  loader: ({ params }) => loadContentMeta("webinars", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/webinar-on-demand/${params.slug}`, loaderData),
  component: WebinarPost,
});

